import IconTwitter from 'resources/images/icon-twitter.png';
import IconFacebook from 'resources/images/icon-facebook.png';
import IconTelegram from 'resources/images/icon-telegram.png';
import IconDiscord from 'resources/images/icon-discord.png';
import IconMedium from 'resources/images/icon-medium.png';

const socialLinks = [
  {
    name: 'Medium',
    icon: IconMedium,
    link: 'https://medium.com/@PirateXPirateNFTsGame'
  },
  {
    name: 'Twitter',
    icon: IconTwitter,
    link: 'https://twitter.com/PXPNFTsGame'
  },
  {
    name: 'Telegram',
    icon: IconTelegram,
    link: 'https://t.me/piratexpiratecommu'
  },
  {
    name: 'Discord',
    icon: IconDiscord,
    link: 'https://discord.gg/PYGnb5HWrt'
  }
];

export { socialLinks };
